export default "__VITE_ASSET__CvwrlnVq__"